import React from "react";
import { t } from "i18next";

function Accounting({ setActiveTab }) {
    return (
        <div className="p-6 flex flex-col items-center justify-center py-16 gap-4">
            <div className="w-16 h-16 rounded-2xl bg-[#147F26]/10 flex items-center justify-center">
                <svg className="w-8 h-8 text-[#147F26]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
            </div>
            <div className="text-center">
                <p className="text-base font-semibold text-gray-800 mb-1">{t('accounting') || 'Бухгалтерия'}</p>
                <p className="text-sm text-gray-400">{t('comingSoon') || 'Жақында қол жетімді болады'}</p>
            </div>
        </div>
    );
}

export default Accounting;
